import { useRef,useEffect } from 'react'
import { useFrame } from '@react-three/fiber'
import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils.js'
import * as THREE from 'three'

export default function Nuages() {

    const nombreNuages = 40
    
    const refNuages = useRef();

    var emptyMatrix = new THREE.Matrix4();
    var newPosition = new THREE.Vector3();
    var newScale = new THREE.Vector3();

    const vitesse = 1.1
    const demiZone = 100
    const longueurFade = 10

    useEffect(() =>
        {
            for(let i = 0; i < nombreNuages; i++) {

                let x = (Math.random()* 2 * (demiZone - longueurFade)) - (demiZone - longueurFade)
                let z = (Math.random()* 2 * (demiZone - longueurFade)) - (demiZone - longueurFade)
                let y = (Math.random()*2) + 5
                let echelle = Math.random() * 1.2 + 0.1

                const positionNuages = new THREE.Matrix4().compose(
                    new THREE.Vector3(x,y,z),
                    new THREE.Quaternion(),
                    new THREE.Vector3(echelle, echelle*0.7 ,echelle)
                )
                refNuages.current.setMatrixAt(i, positionNuages)
            }
        }, [])

    useFrame((state,delta) =>
        {
            for (let i = 0; i < nombreNuages; i++) {

                refNuages.current.getMatrixAt( i, emptyMatrix )
                newPosition.setFromMatrixPosition( emptyMatrix )
                // newScale.setFromMatrixScale( emptyMatrix )
                
                // if(newPosition.z > (demiZone - longueurFade) ) { 
                //     // newScale.x = newScale.x * (1 - (( newPosition.z - (demiZone - longueurFade)  ) / longueurFade))
                //     // newScale.y = newScale.y * (1 - (( newPosition.z - (demiZone - longueurFade) ) / longueurFade))
                //     // newScale.z = newScale.z * (1 - (( newPosition.z - (demiZone - longueurFade) ) / longueurFade))
                //     newScale.x -= newScale.x * vitesse * delta
                //     newScale.y -= newScale.y *  vitesse * delta
                //     newScale.z -= newScale.z * vitesse * delta
                // }

                // if(newPosition.z < - (demiZone - longueurFade)) { 
                //     // newScale.x = newScale.x *  (1 - ( - newPosition.z - (demiZone - longueurFade) ) / longueurFade)
                //     // newScale.y = newScale.y *  (1 - ( - newPosition.z - (demiZone - longueurFade) ) / longueurFade)
                //     // newScale.z = newScale.z *  (1 - ( - newPosition.z - (demiZone - longueurFade) ) / longueurFade)
                //     newScale.x += newScale.x * vitesse * delta
                //     newScale.y += newScale.y * vitesse * delta
                //     newScale.z += newScale.z * vitesse * delta
                //     if(newScale.x > 1.3) {newScale.x = 1.3}
                //     if(newScale.y > 1.3) {newScale.y = 1.3 * 0.7}
                //     if(newScale.z > 1.3) {newScale.z = 1.3}

                //     refNuages.current.material.opacity = 0.2
                // }

                if(newPosition.z  >  demiZone) { newPosition.z -=  (2 * demiZone) }
                
                newPosition.z +=  vitesse * delta

                //emptyMatrix.makeScale( newScale.x, newScale.y, newScale.z )
                emptyMatrix.setPosition( newPosition )
                refNuages.current.setMatrixAt( i, emptyMatrix );

                // console.log(newPosition.z);
            }
            refNuages.current.instanceMatrix.needsUpdate = true;

            
        }

    )
    //refNuages.current.instanceMatrix.setUsage( THREE.DynamicDrawUsage );

    const toutesBoules = []
    const boule = new THREE.SphereGeometry(1, 20, 20);

    const boule1 = boule.clone().scale(1.7,0.8,1)
    toutesBoules.push(boule1)
    
    const boule2 = boule.clone().translate(0.4,0.1,-0.2).scale(1,0.75,1)
    toutesBoules.push(boule2)

    const boule3 = boule.clone().translate(0.4,0,0.4).scale(0.95,0.7,1)
    toutesBoules.push(boule3)

    const boule4 = boule.clone().translate(-0.4,0.1,0.5).scale(0.95,0.75,1)
    toutesBoules.push(boule4)
    
    const boule5 = boule.clone().translate(-0.5,0,-0.35).scale(1,0.65,0.9)
    toutesBoules.push(boule5)


    const nuageGeometry = BufferGeometryUtils.mergeBufferGeometries(toutesBoules)
    const nuageMateriel = new THREE.MeshLambertMaterial({ color: "white", opacity:1, transparent: true })


    //  ARBRES

    const refTroncs = useRef();
    const refArbres = useRef();

    const toutesFeuilles = []
    const feuilles1 = new THREE.ConeGeometry(0.75,1,8)
    feuilles1.translate(0,2,0)
    const feuilles2 = new THREE.ConeGeometry(1,1,8)
    feuilles2.translate(0,1.5,0)
    const feuilles3 = new THREE.ConeGeometry(1.25,1,8)
    feuilles3.translate(0,1,0)
    toutesFeuilles.push(feuilles1)
    toutesFeuilles.push(feuilles2)
    toutesFeuilles.push(feuilles3)
    const feuillesMat = new THREE.MeshLambertMaterial({ color: 0x006600 }) 
    const feuillesMatOr = new THREE.MeshLambertMaterial({ color: 0xCC9900 }) 

    const feuillesGeometry = BufferGeometryUtils.mergeBufferGeometries(toutesFeuilles)


    const tronc = new THREE.CylinderGeometry(0.2,0.2,1)
    const troncMat = new THREE.MeshLambertMaterial({ color: 0xbb6600 }) 
    
    const nombreArbres = 1000

    useEffect(() =>
    {
        for(let i = 0; i < nombreArbres; i++) {

            let angle = Math.random() * Math.PI  * 2
            let radius = 5.5 + Math.random() * 80
            let x = Math.cos(angle) * radius
            let z = Math.sin(angle) * radius
            let y = 0
            let echelleX =0.2
            let echelleY = 0.3 + (Math.random() * 0.05) 
            let echelleZ = 0.2
            let angleX = (Math.random()- 0.5) /4 
            let angleY = (Math.random()-0.5) /4
            let euler = new THREE.Euler(0,angleX,angleY,'YZX')
            const positionArbre = new THREE.Matrix4().compose(
                new THREE.Vector3(x,y,z),
                new THREE.Quaternion().setFromEuler(euler),
                new THREE.Vector3(echelleX, echelleY ,echelleZ)
            )
            refArbres.current.setMatrixAt(i, positionArbre)
            refTroncs.current.setMatrixAt(i, positionArbre)
        }
    }, [])

        
    // ROCHERS

    const nombreRochers = 5
    const refRochers = useRef();
    const refRochers2 = useRef();


    useEffect(() =>
    {
        for(let i = 0; i < nombreRochers; i++) {

            let x = Math.random()* 1
            let z = Math.random()* 1
            let y = Math.random()* 1
            let echelleX = Math.random() / 4 + 1
            let echelleY = Math.random() / 4 + 1
            let echelleZ = Math.random() / 4 + 1
            let angleX = Math.random() * 2
            let angleY = Math.random() * 2
            let angleZ = Math.random() * 1
            let angleW = Math.random()
            let euler = new THREE.Euler(0,angleY,angleZ,'YZX')
            const positionRocher = new THREE.Matrix4().compose(
                new THREE.Vector3(x,y,z),
                new THREE.Quaternion().setFromEuler(euler),
                new THREE.Vector3(echelleX, echelleY ,echelleZ)
            )
            refRochers.current.setMatrixAt(i, positionRocher)
            refRochers2.current.setMatrixAt(i, positionRocher)
        }
    }, [])

    const cube = new THREE.DodecahedronGeometry(2,0)
    const rocherMateriel = new THREE.MeshLambertMaterial({ color: "#777777" }) 



    return <>
        <instancedMesh  castShadow ref={refTroncs} args={[tronc, troncMat, nombreArbres]} position={[0,0,0]} />
        <instancedMesh receiveShadow castShadow ref={refArbres} args={[feuillesGeometry, feuillesMat, nombreArbres]} position={[0,0,0]} />

        <instancedMesh castShadow ref={refNuages} args={[nuageGeometry, nuageMateriel, nombreNuages]} />
        
        <instancedMesh receiveShadow castShadow ref={refRochers} args={[cube, rocherMateriel, nombreRochers]} position={[-2,-1,-15]} />

        <instancedMesh receiveShadow castShadow ref={refRochers2} args={[cube, rocherMateriel, nombreRochers]} position={[2,-1,15]} rotation-y = {Math.PI} /> 

    </>

}
